import ComissionStore from './ComissionStore';
import VoucherStore from './VoucherStore';
import CekSaldoStore from './CekSaldoStore';
import BeliKartuStore from './BeliKartuStore';
import JualBitcoinStore from './JualBitcoinStore';
import TopupBitcoinStore from './TopupBitcoinStore';
import CommonStore from './CommonStore';
import AuthStore from './AuthStore';
import ReferralStore from './ReferralStore';
import ActivationStore from './ActivationStore';

export default {
  CekSaldoStore,
  BeliKartuStore,
  CommonStore,
  AuthStore,
  JualBitcoinStore,
  TopupBitcoinStore,
  ReferralStore,
  VoucherStore,
  ComissionStore,
  ActivationStore,
};
